import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
var url = location.search;
var obj = {};
if (url.indexOf('?') !== -1) {
  var str = url.substr(1);
  var strs = str.split('&');
  strs.forEach(function (item) {
    obj[item.split('=')[0]] = decodeURI(item.split('=')[1]);
  });
}
export default obj;